module.exports = __webpack_public_path__ + "static/img/9.4f58bb25.png";